"use client";

import React, { useRef, useEffect } from 'react';
import ThreeJSApp from '@/shared/lib/threejs/app';
import { cn } from '@/shared/utils/tw';
import { useThreeApp } from '../model/use-three-app';
import { useRenderAndAnimateAvatar } from '@/layouts/avatar-page/model/use-render-avatar';
import type { AvatarType, DisplayMode } from '@/entities/avatar-scenario/const/config';

export interface ThreeCanvasProps {
  className?: string;
  avatarType?: AvatarType;
  displayMode?: DisplayMode;
  onReady?: (app: ThreeJSApp) => void;
  onError?: (error: Error) => void;
  onLoadProgress?: (progress: number) => void;
  enableSuspense?: boolean; // Suspense 활성화 옵션
}

const ThreeCanvas = ({
  className = '',
  avatarType = 'nalnani',
  displayMode = 'web',
  onReady,
  // enableSuspense = false,
}: ThreeCanvasProps) => {
  const canvasRef = useRef<HTMLCanvasElement>(null);
  const { app } = useThreeApp({ canvasRef });
  useRenderAndAnimateAvatar(app, avatarType, displayMode);

  useEffect(() => {
    if (app && onReady) {
      onReady(app);
    }
  }, [app, onReady]);

  return (
    <canvas
      ref={canvasRef}
      className={cn(
        'outline-none',
        'w-full h-dvh',
        'touch-none',
        '[display:block]',
        '[touch-action:none]',
        '[user-select:none]',
        '[-webkit-user-select:none]',
        '[-moz-user-select:none]',
        '[-ms-user-select:none]',
        className
      )}
      draggable={false}
    />
  )
};

ThreeCanvas.displayName = 'ThreeCanvas';

export default ThreeCanvas; 